export default {
  clearAllUsers(context) {
    console.group("clearAllUsers");
    context.commit("CLEAR_ALL_USERS");
    console.groupEnd();
  },
  async loadAllUsers(context) {
    console.group("loadAllUsers");

    // const token = context.rootGetters.token;

    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/users.json`
    );

    const responseData = await response.json();
    console.info("responseData: ", responseData);

    if (!response.ok) {
      const error = new Error(responseData.message || "Failed to fetch users.");
      throw error;
    }

    // successfully retrieved users, clear the current ones
    context.dispatch("clearAllUsers");

    if (responseData !== null) {
      for (const key in responseData) {
        const user = {
          userId: responseData[key].userId,
          userName: responseData[key].userName,
          email: responseData[key].email,
          isAdmin: responseData[key].isAdmin,
          dateAdded: new Date(responseData[key].dateAdded),
        };

        console.info("key = ", key, " user = ", user);
        context.dispatch("loadUser", user);
      }
    }

    console.info("userProfiles = ", context.getters.userProfiles.length);
    console.groupEnd();
  },
  loadUser(context, user) {
    console.group("loadUser");
    context.commit("LOAD_USER", user);
    console.groupEnd();
  },
  createUserProfile(context, payload) {
    console.group("createUserProfile")
    console.info("payload = ", payload);

    const userProfile = {
      userId: payload.userId,
      userName: payload.email.substr(0, payload.email.indexOf("@")),
      email: payload.email,
      isAdmin: false,
      dateAdded: new Date(),
    };

    context.commit("CREATE_USER_PROFILE", userProfile); // add to userProfiles list
    context.dispatch("setCurrentUser", payload.userId); // add to currentUser object
    context.dispatch("updateUserProfile", userProfile); // add to database
    console.groupEnd();
  },
  async updateUserProfile(context, payload) {
    console.group("updateUserProfile");
    const token = context.rootGetters.token;
    const userId = context.rootGetters.userId;
    var profile = new Object();
    const newUserName = context.rootGetters.userName !== payload.userName;
    const newEmail = context.rootGetters.email !== payload.email;

    console.info("payload = ", payload);

    if (!newUserName && !newEmail) {
      // relevant data unchanged
      console.info("same UserName and Email");
      console.info("current userName = ", context.rootGetters.userName);
      console.info("current email = ", context.rootGetters.email);
    }

    // relevant data changed
    Object.assign(profile, context.rootGetters.currentUser);
    profile.userName = payload.userName;
    profile.email = payload.email;

    if (!userId || userId === "") {
      const error = new Error("Unable to update user, no Current User.");
      throw error;
    }

    // if we changed the email address, we have to change it in the Firebase user auth
    // let's do that first to make sure it is successful
    if (newEmail) {
      context.dispatch("changeUserEmail", payload.email);
    }

    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/users/${userId}.json?auth=` +
        token,
      {
        method: "PUT",
        body: JSON.stringify(profile),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to save user profile."
      );
      throw error;
    }

    context.commit("UPDATE_USER_PROFILE", profile);
    context.dispatch("setCurrentUser", userId);
    console.groupEnd();
  },
  // deleteUserProfile(context, userId) {

  // },
  setCurrentUser(context, userId) {
    console.group("setCurrentUser");
    context.commit("SET_USER_PROFILE", userId);
    context.dispatch("picks/setCurrentPicks", userId);
    console.groupEnd();
  },
  clearCurrentUser(context) {
    console.group("clearCurrentUser");
    context.commit("CLEAR_USER_PROFILE");
    context.dispatch("picks/clearCurrentPicks");
    console.groupEnd();
  },
};
